import { useAccountQuery, useGetSubscriptions } from 'src/react_query'
import { useFeatureAccess } from './useFeatureAccess'
import {
  FullAccessFeatureType,
  PlansPlanTypeChoices,
  StripeSubscriptionWithItemsFragment,
} from 'src/graphql/generated/graphql'
import { ACT_ADDON_STRIPE_ID } from 'src/marketing/plans/constants'
import { PLAN_IDS } from 'src/app/constants'

type UpsaleType = 'actAddOn' | 'monthlyAct' | 'casualSender'

export const useCurrentUpsale = () => {
  const getUpsalePlanId = (upsale?: UpsaleType) =>
    ({
      actAddOn: PLAN_IDS.ACT_ADDON,
      monthlyAct: PLAN_IDS.ACT,
      casualSender: PLAN_IDS.CASUAL,
    })[upsale!]

  const { data: account } = useAccountQuery()
  const { data: subscriptions } = useGetSubscriptions()
  const { hasFeatureAccess: hasLifetimeAct } = useFeatureAccess([
    FullAccessFeatureType.UnlimitedActsSubDiscount,
  ])

  const currentActivePlan = account?.plan
  const hasNoSubscription = currentActivePlan?.id === '1'
  const hasActAddOn = subscriptions
    ?.find(
      (sub: StripeSubscriptionWithItemsFragment) =>
        sub.sku === currentActivePlan?.stripeId,
    )
    ?.items.find(subItem => subItem.sku === ACT_ADDON_STRIPE_ID)
  const hasLegacyPlan =
    currentActivePlan &&
    currentActivePlan.type === PlansPlanTypeChoices.Main &&
    currentActivePlan.isLegacy
  const shouldUpsaleActAddOn = hasLegacyPlan && !hasLifetimeAct && !hasActAddOn
  const shouldUpsaleMonthlyAct = hasNoSubscription && !hasLifetimeAct

  return {
    plan: getUpsalePlanId(
      shouldUpsaleActAddOn
        ? 'actAddOn'
        : shouldUpsaleMonthlyAct
          ? 'monthlyAct'
          : undefined,
    ),
  }
}
